import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import EventSignupQuestions from "./EventSignupQuestions";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../utils/firebase";


export default function SignupAnswersSection({ participant, signupAnswers, event, eventId, isAdmin, isSelf, setEvent, setSelectedParticipant }) {
  const [editMode, setEditMode] = useState(false);
  const [answers, setAnswers] = useState(signupAnswers || {});

  useEffect(() => {
    setAnswers(signupAnswers || {});
  }, [signupAnswers]);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setAnswers(a => ({ ...a, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSave = async () => {
    try {
      if (!participant?.id) {
        // cannot save without participant doc id
        setEditMode(false);
        return;
      }
      await updateDoc(doc(db, "participants", participant.id), { answers });
      setSelectedParticipant(sp => ({ ...sp, signupAnswers: answers, answers }));
      setEvent(ev => ev); // no event-level change required
      setEditMode(false);
    } catch (e) {
      // optionally surface error
      setEditMode(false);
    }
  };

  // Only allow editing if:
  // - The user is viewing their own answers (isSelf) AND not in admin view
  // - OR the admin has clicked Edit (isAdmin && editMode)
  // If admin is viewing, user cannot edit
  const canEdit = (isAdmin && editMode) || (!isAdmin && isSelf);

  return (
    <Box sx={{ mt: 2, mb: 1, p: 2, bgcolor: '#f5f5f5', borderRadius: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>Signup Form Answers</Typography>
      <EventSignupQuestions
        values={answers}
        onChange={canEdit ? handleChange : undefined}
        readOnly={!canEdit}
      />
      {isAdmin && !editMode && (
        <Button sx={{ mt: 1 }} onClick={() => setEditMode(true)} variant="outlined">Edit</Button>
      )}
      {isAdmin && editMode && (
        <Box sx={{ mt: 1, display: 'flex', gap: 1 }}>
          <Button onClick={handleSave} variant="contained">Save</Button>
          <Button onClick={() => { setEditMode(false); setAnswers(participant.signupAnswers || {}); }} variant="outlined">Cancel</Button>
        </Box>
      )}
    </Box>
  );
}
